import './styles';
import 'angular-cookie/angular-cookie.js';

import moment from 'moment';
import list from 'ngtemplate-loader!./list.tpl.html';

export const moduleName = 'rezflow.giftList'
export const name = 'giftList';

const today = moment.utc(new Date()).endOf('day');

export class Gift {

  constructor(gift, api) {
    this.api = api;
    angular.extend(this, gift);
    if (this.expiration) this.expiration = moment.utc(this.expiration);
    this.purchaser = this.contact.purchaser;
    this.recipient = this.contact.recipient;
    this.expired = this.isExpired();
    this.has_balance = this.balanceDue() > 0;
    if (this.has_balance && this.code === '6F1-2E-36C') {
      console.log(this.discountTotal, this.amount, this.payments);
    }
  }

  isExpired() {
    if (!this.expiration) return false;
    return this.expiration.isBefore(today)
  }

  send(){
    this.sending = true;
    const API = this.api.req();
    const Send = API.voucher({ id: this._id }).$promise;
    this.sending = true;
    Send.then((sendRes) => {
      this.isSent = true;
      this.sending = false;
    }).catch(console.error);
  }

  receipt() {
    this.sendingReceipt = true;
    const API = this.api.req();
    const Send = API.receipt({ id: this._id }).$promise;
    this.sendingReceipt = true;
    Send.then((sendRes) => {
      this.isSentReceipt = true;
      this.sendingReceipt = false;
    }).catch(console.error);
  }

  delete(){
    bootbox.dialog({
      message: "<p><strong>This can not be undone.</strong> If you still want to remove this prepaid purchase then please type <code>DELETE</code> below:</p><div class='form-group bg-light' style='padding: 26px;margin: 0 -20px -1px -20px;margin-bottom: -35px;'><input type='text' id='result' class='form-control' /></div>",
      title: "Removing <code>" + this.code + "</code>. Are you sure?",
      buttons: {
        success: {
          label: "Remove",
          className: "btn-primary",
          callback: () => {
            var result = $('#result').val();
            if (result == 'DELETE') {
              const API = this.api.req();
              const Delete = API.delete({ id: this.id }).$promise;
              Delete.then((giftRes) => {
                this.removed = true;
              }).catch(console.error)
            }
          }
        },
        cancel: {
          label: "Cancel",
          className: "btn-default",
          callback: function () { }
        }
      }
    });
  }

  get discountTotal() {
    const amount = this.amount;
    const discount = this.discount || '0';
    const matched = discount.match(/^(\$)?((\d+)\.?(\d+)?)(\%)?$/);
    const isPercent = matched && matched[3] !== undefined || false;
    let discountValue = parseFloat(matched && matched[2] || 0);
    if (isPercent) discountValue = (amount) / (100 / discountValue);
    return discountValue;
  }

  get payments() {
    const payments = this.cards.filter((card) => card.charges.length).filter((card) => card.charges.length).reduce((prevCard, card) => {
      const charges = card.charges.reduce((prevCharge, charge) => {
        return charge.amount + prevCharge;
      }, 0);
      return prevCard + charges;
    }, 0);
    const discount = this.discountTotal;
    return (payments || 0) + discount;
  }

  balanceDue() {
    if (this.type === 'donation' || this.type === 'promo') return false;
    return this.amount - this.payments;
  }

  giftBalance() {
    const giftValue = this.amount;
    const used = this.used.reduce((prev, curr) => {
      return prev + curr.amount;
    }, 0)
    return giftValue - used;
  }

}

const initStartPages = 6;

export class GiftList {

  /* @ngInject */
  constructor($scope, $filter, GiftAPI, $state, $rootScope, $location, $transitions) {
    const vm = this;
    this.$scope = $scope;
    this.$filter = $filter;
    this._api = GiftAPI;
    this.$state = $state;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.pendingGifts = ($rootScope.pendingGifts || []).map((gift) => this.initGift(gift, this.api));
    this.user = $rootScope.user;
    this.company = this.user ? this.user.activeCompany : undefined;
  }

  get api() {
    return this._api;
  }

  search(evt) {
    // enter key
    if (evt.keyCode == 13) {
      const API = this.api.req();
      const Search = API.search({ q: this.q }).$promise;

      Search.then((giftRes) => {
        this.isSearch = true;
        this.page = 1;
        this.count = giftRes.count;
        this.gifts = giftRes.results.map((gift) => this.initGift(gift, this.api));
      }).catch(console.error);
    }

    // Escape key
    if (evt.keyCode == 27) {
      this.search = ""
      this.gifts = this.gifts;
    }
  }

  get maxPages() {

    if (this.pageCount < initStartPages) return this.pageCount;

    const pagesLeft = this.pageCount - this.page;

    const isBeginning = this.page <= initStartPages - 2;
    const isEnding = pagesLeft <= initStartPages - 2;

    const endOfBeginning = this.page === initStartPages - 1;
    const startOfEnding = pagesLeft === initStartPages - 1;

    const isScrolling = this.page >= initStartPages && this.page;

    if (isBeginning || isEnding) return initStartPages + 1;
    if (endOfBeginning) return initStartPages + 1;
    if (isScrolling) return initStartPages - 1;
    return initStartPages;
  }

  initGift(gift, api) {
    return new Gift(gift, api);
  }

  get pageCount() {
    return Math.ceil(this.count / 50);
  }

  get pageTail() {
    return Math.floor(initStartPages / 2)
  }

  get pageHead() {
    const head = Math.ceil(initStartPages / 2);
    if(this.page === initStartPages - 1) return head + 1;
    return head;
  }

  get pages() {
    const pageCount = this.pageCount;
    let maxPages = this.maxPages;
    let startCount = this.page >= initStartPages ? this.page - this.pageTail : 0;
    if (this.pageCount - this.page <= this.pageHead) startCount = this.pageCount - maxPages;
    return Array.apply(null, { length: maxPages }).map((n,i) => {
      return i + 1 + startCount;
    });
  }

  get purchaser() {
    return this.gift.contact.purchaser;
  }

  get recipient() {
    return this.gift.contact.recipient;
  }

  $onInit() {
    this.count = this.gifts.count;
    this.type = this.gifts.type;
    this.page = Number.parseInt(this.gifts.page, 10);
    const gifts = this.gifts.results.filter((gift) => {
      const id = gift._id;
      const pendingIndex = (this.pendingGifts || []).findIndex((p) => {
        return p._id === id;
      });
      return pendingIndex === -1;
    }).map(gift => {
      return this.initGift(gift, this.api);
    })
    
    this.gifts = gifts.filter(g => !g.has_balance);
    this.giftsBalance = gifts.filter(g => g.has_balance);
    this.init();
  }

  init() {}

}

export default (MODULE) => {

  angular.module(MODULE)
    .component(name, {
      bindings: {
        gifts: '=',
        company: '<'
      },
      templateUrl: list,
      controller: GiftList
    });

  return name;

};


// WEBPACK FOOTER //
// ./client/assets/scripts/modules/gifts/index.js